__webpack_require__.p = "https://salesmanual-nonprod-exo.tissot.ch/";